import { render, staticRenderFns } from "./annotation-base.vue?vue&type=template&id=77ab5d6c"
import script from "./annotation-base.vue?vue&type=script&lang=js"
export * from "./annotation-base.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports